/**
 * Account URLs carry the ENTITY (plan: `/a/:entity/:code`). A code alone is not an
 * account — the same code can exist in uk and us — and a link that relied on the
 * reader's last-used filter opened a different account, or a 404, for anyone whose
 * filter said otherwise.
 */
import { knownEntity } from './home-entity.js';

export function accountUrl(code, entity, { tab, focus } = {}) {
  const e = entity || knownEntity();
  const q = new URLSearchParams();
  if (tab) q.set('tab', tab);
  if (focus) q.set('focus', focus);
  const qs = q.toString();
  // 🔴 no entity known yet (a fresh tab): the legacy /customers/:code route asks the server
  // for the person's home entity and redirects — never a guessed 'uk' (sweep R2 #48)
  if (!e) return `/customers/${encodeURIComponent(code)}${qs ? `?${qs}` : ''}`;
  return `/a/${encodeURIComponent(e)}/${encodeURIComponent(code)}${qs ? `?${qs}` : ''}`;
}

/** Tell the shell which entity the page is showing (as-of chip, + New defaults). */
export function announceEntity(entity) {
  if (entity) window.dispatchEvent(new CustomEvent('sales:entity', { detail: entity }));
}

/** A part is addressed with its entity too; part numbers carry slashes (RNF-100-6/2-X-SP). */
export function partUrl(part, entity, { customer, qty, by } = {}) {
  const e = entity || knownEntity();
  const q = new URLSearchParams();
  if (customer) q.set('customer', customer);
  if (qty) q.set('qty', qty);
  if (by) q.set('by', by);
  if (!e) {                 // as accountUrl: the /part route resolves the home entity first
    q.set('n', part);
    return `/part?${q.toString()}`;
  }
  const qs = q.toString();
  return `/p/${encodeURIComponent(e)}/${encodeURIComponent(part)}${qs ? `?${qs}` : ''}`;
}

